import * as ACTION from './constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function*() {
    yield takeLatest(ACTION.GET_BAG_PACKING_DETAIL.REQUEST, saga.getBagDetail);
    // yield takeLatest(ACTION.GET_BAG_PACKING_DETAIL.SUCCESS, saga.getBagDetailAfterPacking);
    yield takeLatest(ACTION.GET_BAG_PACKING_DETAIL.FAILED, saga.onFetchBagDetailFailed);
}